import React, { useEffect, useState } from "react";
import { message } from "antd";
import LinkPlaid from "../../../../../../components/buttons/linkplaid";
import LinkToDashboard from "./linkToDashboard";
import GenericDeleteModal from "../../../../../../components/buttons/genericDeleteModal";
import GenericDropdown from "../../../../../../components/generic/genericDropdown";
import EditOrAddSFTPModal from "../../../../../../components/specific/manageConnections/editOrAddSftpModal";
import UpdateManualAccountBalance from "../../../../../../components/bankAccount/updateManualAccountBalance";
import { amountStrtoFloat } from "../../../../../../helpers/stringFormat";
import Box from "@mui/material/Box"
import ConnectionsDetailsEditModal from "./ConnectionsDetailsEditModal";


function ExternalConnectionsRowDropdown(props) {
  const [dropdownItems, setDropdownItems] = useState([]);
  const [editModalVisible, setEditModalVisible] = useState(false)

  const removeConnection = async () => {
    message.success("Successfully removed this account");
    props.setExternalConnections((prevState) => {
      const updatedUnlinkedAccounts = prevState.filter(
        (item) => {
          return item.id !== props.record.id;
        }
      );
      return updatedUnlinkedAccounts;
    });
  };

  const accessTokenOnSuccess = (plaidAccountsResponse, type) => {
    let plaidAccounts = plaidAccountsResponse?.plaid_accounts || [];

    props.setExternalConnections((prevState) => {
      let unlinkedAccounts = prevState;

      unlinkedAccounts = unlinkedAccounts.map((item) => {
        plaidAccounts.forEach((account) => {
          if (
            item.id === account.id &&
            item.source === account.source
          ) {
            item = { ...item, ...account }
          }
        });

        return item;
      });

      return unlinkedAccounts;
    });
  };

  const linkPlaidComponent = <LinkPlaid
    buttonText={<a>Manage connection</a>}
    type="reconnect"
    plaidAccountId={parseInt(props.record.id)}
    isAssigned={false}
    accessTokenOnSuccess={accessTokenOnSuccess}
  />;

  const onManualBalanceUpdateSuccess = (response) => {
    props.setExternalConnections(prevState => {
      return prevState.map(acc => {
        if (acc.id === response.data?.id && acc.source === response.data?.account?.account_source) {
          return {
            ...acc,
            last_current_balance: amountStrtoFloat(response.data?.account?.current_balance),
          }
        }
        return acc;
      })
    })
  };

  useEffect(() => {
    let newDropdownItems = []

    {/* only if its not linked to dashboard */ }
    if (!props.record.is_assigned) {
      newDropdownItems.push(
        <LinkToDashboard
          source={props.record.source}
          sourceId={parseInt(props.record.id)}
          institutionName={props.record.institution_name}
          accountDescription={props.record.description}
          entityName={props.record.beneficiary_name}
          onLinkToDashboardSuccess={props.onLinkToDashboardSuccess}
          subPortfolios={props.subPortfolios}
          unlinkedProperties={props.unlinkedProperties}
          accountNumberLast4={props.record.account_number_last_4}
          type={'assign'}
          groups={props.groups}
          flattenedTags={props.flattenedTags}
          flattenedTagsLoading={props.flattenedTagsLoading}
          groupsLoading={props.groupsLoading}
        />
      );
    }

    if (props.record.source === "MA" && !props.record.is_shared) {
      newDropdownItems.push(
        <a>
          <UpdateManualAccountBalance
            button={'Update Balance'}
            bankAccountInfo={props.record}
            balance={props.record.last_current_balance}
            bankId={parseInt(props.record.id)}
            updateBalanceSuccess={onManualBalanceUpdateSuccess}
          />
        </a>)
    }

    {/* if source FI, institution Chase, status not live, is assigned */ }
    // Plaid manage connection
    if (props.record.source === "PL" && !props.record.is_shared) {
      newDropdownItems.push(linkPlaidComponent)
    }

    // Finicity manage connection
    if (props.record.source === "FI" && props.record.connect_url.length > 0 && !props.record.is_shared) {
      newDropdownItems.push(
        <a href={props.record.connect_url} target="_blank" rel="noreferrer">
          Reconnect
        </a>
      )
    }

    {/* for now we will hide editing sftp connection */ }
    if (false && props.record.source === "FT") {
      newDropdownItems.push(
        <EditOrAddSFTPModal
          record={props.record}
          onSuccess={props.onEditSFTPAccountSuccess}
          add={false}
        />
      )
    }

    newDropdownItems.push(
      <a onClick={() => { setEditModalVisible(true) }}>Edit</a>
    )

    if (true || !props.record.is_assigned) {
      newDropdownItems.push(
        <GenericDeleteModal
          type='External Connection'
          title={`Are you sure you want to delete ${props.record.description} (...${props.record.account_number_last_4})?`}
          URL={'/api/external-connections/'}
          deleteParams={{
            "sourceAccountInfo": [{
              "source": props.record.source,
              "sourceAccountId": parseInt(props.record.id)
            }]
          }}
          description={`By clicking Delete below you will lose the connection to the account ${props.record.description} (...${props.record.account_number_last_4}) on your dashboard. This will break the connection for any associated connected dashboard account. If you do not want to proceed or unsure, please click X on the upper right.`}
          handleDeleteSuccess={removeConnection}
          handleDeleteFailure={() => message.error(`Failed to delete the external connection with ${props.record.description} (...${props.record.account_number_last_4})`)}
        />
      )
    }


    setDropdownItems(newDropdownItems)

  }, [props.record, props.subPortfolios, props.properties])

  return (
    <Box>
      <GenericDropdown dropdownItems={dropdownItems} />
      {editModalVisible && (
        <ConnectionsDetailsEditModal
          connections={props.connections}
          setConnections={props.setExternalConnections}
          editableObject={props.record}
          modalVisible={editModalVisible}
          handleCancelModal={() => setEditModalVisible(false)}
        />
      )}
    </Box>
  );
}

export default ExternalConnectionsRowDropdown